/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef } from "react";
import { useNavigate, Link} from 'react-router-dom';
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons'
import { Analytics, Gtag } from '../compornents/Analytics';
export const Login = () => {
  const navigate = useNavigate();
  const [tel, setTel] = useState("");
  const telInputRef = useRef(null);
  // 未登録の電話番号(E025)でログインしようとした場合の案内。toastは消えてしまい、
  // 画面下の「新規登録はこちら」に気づかず離脱していたため、入力欄の直下に直リンクを出す（2026-09-03）
  const [notRegistered, setNotRegistered] = useState(false);

  // モーダル
  const [Modal, openModal, closeModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });

  async function send_sms() {
    openModal();
    setNotRegistered(false);
    const request_data = {
      'key': 'yt~z7ESU6J~tLB7ppw(CLD8WddX9PNsr6DH',
      'tel': tel,
      'is_register': 0,
    }
    // post
    const response_data = await Post('public', '/auth/send_sms.php', request_data);
    if (response_data.result === 1) {
      navigate("/login/auth", { state: { customerId: response_data.customer_id,tel:tel } });
      // SMS送信成功
      Gtag('login_send_sms_success');
    } else {
      // SMS送信失敗
      Gtag('login_send_sms_failed', {
        error_message: response_data.error_message,
      });
      // エラー
      if (response_data.error_code === 'E025') {
        setNotRegistered(true);
      } else {
        toast.error(response_data.error_message);
      }
    }
    closeModal();
  }


  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    Gtag('view_login');
    if (telInputRef.current) {
      telInputRef.current.focus(); // ← 2. マウント時にフォーカス
    }
  }, []);
  return (
    <div>
      <Analytics title="携帯電話番号入力" />
      <div className="Register m-auto">
        <div className="App-tel">
          <div className="auth-logo">
            <img src="./img/header_logo.png" alt="LAUNDRY PACK" />
          </div>
          <div className="tel-title">{"ログイン(SMS認証)"}</div>
          <div className="App-comment">{"本人確認のため、携帯電話のSMS(ショートメッセージサービス)を利用して認証を行います。電話番号が他のお客様に公開されることはありません。"}</div>
          <div className="App-telno">
            <input ref={telInputRef} type="tel" value={tel} onChange={e => { setTel(e.target.value); setNotRegistered(false); }} placeholder="例）09012345678" className="form-control" />
            {notRegistered && (
              <div className="mt-2 border rounded p-3 text-left" style={{ borderColor: '#f5c2c7', background: '#fff5f5' }}>
                <div className="text-danger mb-2" style={{ fontSize: 13 }}>
                  この電話番号は登録されていません。はじめての方は新規登録をお願いします。
                </div>
                <Link to="/register/postcode" state={{ tel }} className="btn btn-sm btn-oval btn-yellow w-100" onClick={() => Gtag('login_to_register_from_e025')}>
                  新規登録へ進む（無料）
                </Link>
                {/* マンション版のお客様が Now版に来てしまうことがある（10/10 バウス津田沼のお客様・検索から Now版でログインを試して4回失敗）。
                    会員は別なので、マンション版のログインへの道を出す */}
                <div className="mt-3 pt-2" style={{ borderTop: '1px dashed #f5c2c7', fontSize: 13 }}>
                  マンションのロッカーでご利用の方（ランドリーパック マンション）は、こちらからログインしてください。
                  <a href="https://mansion.laundrypack.app/login" className="d-block mt-1" style={{ fontWeight: 700 }}
                    onClick={() => Gtag('login_to_mansion_from_e025')}>
                    マンション版のログインへ ›
                  </a>
                </div>
              </div>
            )}
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px',
          }}>
            {tel.length === 11 ? <button className="button-next" onClick={send_sms}>{"次へ"}</button> : <button className="button-next-g">{"次へ"}</button>}
          </div>
          {/* 2026-08-21: 「LINEでログイン」は撤去。ログインはSMS認証に統一（新規登録は8/15に統一済み）。
              LINEはマイページ(Account)からの連携＋お知らせ配信の用途のみ残す。 */}
          <div className="text-center mt-3">
            <Link to="/register" className="text-black">新規登録はこちら</Link>
          </div>
        </div>
      </div>
      <Modal>
        <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
          <button onClick={closeModal} className="hide">閉じる</button>
          <div >
            <TailSpin stroke="#000" />
          </div>
          <div className="">
            <div className="">
              処理中です
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
